import ReviewsCarousel from './ReviewsCarousel';
import { useState } from 'react';

import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';

const proofItems = [
  'быстро выйти на рынок;',
  'протестировать гипотезы;',
  'увеличить поток клиентов;',
  'запустить рекламу в Яндекс Директ и Google;',
  'собрать заявки через формы обратной связи.',
];

const taskItems = [
  'привлекать клиентов из рекламы;',
  'увеличивать конверсии сайта;',
  'презентовать продукт или услугу;',
  'собирать контакты через формы;',
  'автоматизировать обработку заявок;',
  'тестировать офферы и гипотезы;',
  'запускать новые направления бизнеса.',
];

const landingTypes = [
  {
    title: 'Продающий лендинг',
    paragraphs: [
      'Продающий лендинг создается для увеличения продаж. Он включает сильные офферы, триггеры доверия, отзывы клиентов и блоки преимуществ.',
      'Такой landing page:',
    ],
    bullets: ['усиливает конверсию;', 'закрывает возражения;', 'мотивирует оставить заявку;', 'работает на привлечение клиентов.'],
  },
  {
    title: 'Лендинг под рекламу',
    paragraphs: [
      'Лендинг под рекламу создается для запуска трафика из Яндекс Директ, Google Ads и социальных сетей.',
      'Он отличается:',
    ],
    bullets: [
      'быстрой загрузкой;',
      'адаптацией под мобильные устройства;',
      'четкой структурой блоков;',
      'акцентом на целевое действие.',
    ],
  },
  {
    title: 'Одностраничный сайт (Landing Page)',
    paragraphs: ['Классический одностраничный сайт подходит для презентации услуг или продукта.', 'Он включает:'],
    bullets: [
      'главный экран;',
      'блоки преимуществ;',
      'описание услуги;',
      'отзывы;',
      'формы обратной связи;',
      'контакты.',
    ],
    outro: 'Такой сайт легко масштабировать и использовать в рекламе.',
  },
  {
    title: 'Лендинг с квизом и формами захвата',
    paragraphs: [
      'Квиз-лендинг помогает увеличить конверсию за счет интерактива. Пользователь отвечает на вопросы и оставляет заявку.',
      'Преимущества:',
    ],
    bullets: ['высокий уровень вовлечения;', 'сбор данных о клиентах;', 'увеличение количества лидов.'],
  },
  {
    title: 'Персонализированные лендинги',
    paragraphs: [
      'Создаются под сложные задачи бизнеса. Включают интеграции с CRM, аналитикой и внешними сервисами.',
      'Такие лендинги:',
    ],
    bullets: [
      'адаптируются под аудиторию;',
      'учитывают поведение пользователей;',
      'позволяют отслеживать данные и эффективность.',
    ],
  },
];

const includedSteps = [
  ['Аналитика и проектирование', 'Проводится анализ бизнеса, конкурентов и целевой аудитории. Формируется структура сайта и прототип.'],
  ['UX/UI дизайн лендинга', 'Создается уникальный дизайн, который усиливает конверсии. Продумываются блоки, кнопки и сценарии поведения пользователя.'],
  ['Разработка и верстка', 'Выполняется адаптивная верстка. Лендинг корректно работает на всех устройствах.'],
  ['SEO-оптимизация лендинга', 'Настраиваются мета-теги, структура заголовков и скорость загрузки. Это важно для продвижения в поисковых системах. Подробнее здесь.'],
  ['Тестирование и запуск', 'Проверяются формы, кнопки и интеграции. После этого сайт запускается и подключается аналитика.'],
];

const technologies = [
  {
    title: 'Frontend',
    paragraphs: ['Используются современные технологии для создания интерфейса. Лендинг выглядит быстро и удобно.'],
  },
  {
    title: 'Backend',
    paragraphs: ['Настраивается обработка данных, интеграции и логика сайта.'],
  },
  {
    title: 'CMS и платформы (Tilda, WordPress и др.)',
    paragraphs: ['Используются популярные платформы:'],
    bullets: ['Tilda;', 'WordPress;', 'кастомные решения.'],
  },
  {
    title: 'Интеграции и API',
    paragraphs: ['Подключаются:'],
    bullets: ['CRM системы;', 'аналитика (Яндекс Метрика);', 'мессенджеры;', 'формы обратной связи.'],
  },
];

const creationSteps = [
  ['Анализ и бриф', 'Собирается информация о проекте и целях.'],
  ['Проектирование структуры (прототип)', 'Создается логика страниц и блоков (маркетологом ТОП-уровня).'],
  ['Дизайн лендинга', 'Разрабатывается визуальная часть.'],
  ['Разработка', 'Выполняется верстка и программирование.'],
  ['Запуск и оптимизация', 'Сайт запускается и анализируется.'],
];

const collaborationFormats = [
  ['Разработка лендинга под ключ', 'Полный цикл создания сайта.'],
  ['Выделенная команда', 'Команда работает как отдел разработки.'],
  ['Почасовая работа', 'Подходит для доработок.'],
];

const deliverables = [
  ['Готовый продающий лендинг', 'Полностью настроенный сайт.'],
  ['Оптимизацию под рекламу и SEO', 'Сайт готов к продвижению.'],
  ['Удобную систему управления', 'Простое редактирование контента.'],
  ['Масштабируемую структуру', 'Можно добавлять новые блоки.'],
];

const supportItems = [
  ['Техническая поддержка', 'Обслуживание сайта после запуска.'],
  ['SLA и гарантии', 'Фиксированные условия поддержки.'],
  ['Доработки', 'Добавление новых функций.'],
  ['Продвижение лендинга', 'SEO и реклама.(Да-да seo лендинга тоже возможно в некоторых кейсах, и мы это знаем)'],
];

const priceRows = [
  ['Простой лендинг', '7–10 дней', 'от 30 000 ₽'],
  ['Продающий лендинг', '10–14 дней', 'от 50 000 ₽'],
  ['Лендинг с интеграциями', '2–3 недели', 'от 80 000 ₽'],
];

const relatedServices = [
  { href: '/services/websites/seo/', title: 'Разработка под Seo' },
  { href: '/services/websites/context/', title: 'Разработка под контекстную рекламу' },
  { href: '/services/websites/corporate/', title: 'Разработка корпоративного сайта' },
  { href: '/services/websites/redesign-support/', title: 'Редизайн и поддержка' },
];

const reviews = [
  {
    name: 'Алексей М.',
    role: 'владелец интернет-магазина техники',
    full: 'Алексей М., владелец интернет-магазина техники',
    text: 'Заказывал создание лендинга под ключ для запуска рекламы. Нужно было быстро сделать одностраничный сайт под конкретный продукт в сезон. Команда провела анализ аудитории, собрала структуру и сделала продающий дизайн. Лендинг запустили за 10 дней. Уже в первую неделю получили заявки с Яндекс Директ. Конверсия выросла почти в 2 раза по сравнению с предыдущей страницей.',
  },
  {
    name: 'Елена К.',
    role: 'маркетолог онлайн-школы',
    full: 'Елена К., маркетолог онлайн-школы',
    text: 'Нужен был лендинг для запуска нового курса. Рассматривали конструкторы, но решили заказать разработку лендинга у специалистов. В итоге получили полностью готовый сайт с уникальным дизайном, формами обратной связи и интеграцией с CRM. Очень понравилось, что учли все пожелания по структуре и контенту. После запуска реклама начала приносить стабильные лиды.',
  },
  {
    name: 'Дмитрий С.',
    role: 'руководитель строительной компании',
    full: 'Дмитрий С., руководитель строительной компании',
    text: 'Обращался за созданием лендинг сайта для услуги ремонта. До этого был обычный сайт, но он плохо конвертировал. После разработки нового лендинга увеличилось количество заявок и звонков. Особенно хорошо сработали блоки с отзывами и кейсами. Сейчас продолжаем сотрудничество по продвижению и доработкам. Лучше обратитесь к команде спецов, чем сами ковыряйтесь с нейросетями, как сейчас модно.',
  },
];

const faqItems = [
  {
    question: 'Сколько стоит разработка лендинга?',
    blocks: [
      'Стоимость разработки лендинга зависит от задач проекта. Влияют структура, дизайн, функционал и сроки.',
      'Примерно:',
      ['простой лендинг — от 30 000 ₽', 'продающий лендинг под рекламу — от 50 000 ₽', 'лендинг с интеграциями и аналитикой — от 80 000 ₽'],
      'Точную цену можно рассчитать после анализа задачи. Для этого достаточно оставить заявку.',
    ],
  },
  {
    question: 'Почему так, как мы, лендинг не сделает ИИ?',
    blocks: [
      'Нейросети и конструкторы помогают быстро создать шаблонный сайт. Но они не решают ключевую задачу бизнеса — продажи.',
      'ИИ не учитывает:',
      [
        'поведение целевой аудитории;',
        'маркетинговый анализ конкурентов;',
        'структуру, влияющую на конверсии;',
        'смыслы и триггеры принятия решения;',
        'индивидуальный подход к продукту.',
      ],
      'Разработка лендинга специалистами — это не просто создание страницы. Это комплексный процесс: аналитика, дизайн, тестирование и оптимизация.',
      'Поэтому лендинги, сделанные вручную, дают больше заявок и лучше работают в рекламе. Лучше вложиться сейчас - и получить продажи, чем пробовать самим - и потратить время.',
    ],
  },
  {
    question: 'Сроки создания лендинга?',
    blocks: [
      'Срок разработки зависит от сложности проекта.',
      'В среднем:',
      ['базовый лендинг — 7–10 дней', 'продающий лендинг — 10–14 дней', 'сложный проект с интеграциями — до 21 дня'],
      'Сроки фиксируются до начала работ и прописываются в договоре.',
    ],
  },
  {
    question: 'Что нужно для старта?',
    blocks: [
      'Чтобы начать разработку лендинга, достаточно:',
      [
        'кратко описать задачу;',
        'указать нишу бизнеса;',
        'рассказать о продукте или услуге;',
        'обозначить цели (заявки, продажи, лиды).',
      ],
      'Все остальное — анализ, структура, тексты и дизайн — команда берет на себя.',
    ],
  },
  {
    question: 'Подходит ли лендинг для рекламы?',
    blocks: [
      'Да, лендинг — лучший формат сайта для рекламы.',
      'Он идеально подходит для:',
      ['Яндекс Директ;', 'Google Ads (если ваш бизнес за границей);', 'рекламы в социальных сетях;', 'трафика из мессенджеров.'],
      'Одностраничный сайт быстрее загружается, лучше удерживает внимание и ведет пользователя к целевому действию.',
    ],
  },
  {
    question: 'Чем лендинг отличается от обычного сайта?',
    blocks: [
      'Лендинг — это одностраничный сайт с четкой целью. Он ведет пользователя по одному сценарию.',
      'Обычный сайт:',
      ['имеет много страниц;', 'подходит для SEO по большой семантике и информации.'],
      'Лендинг:',
      ['сфокусирован на продаже;', 'увеличивает конверсии;', 'лучше работает в рекламе.'],
    ],
  },
  {
    question: 'Можно ли сделать лендинг на Tilda или WordPress?',
    blocks: [
      'Да, лендинг можно создать на разных платформах:',
      ['Tilda — быстро и удобно;', 'WordPress — больше возможностей;', 'индивидуальная разработка — максимальный функционал.'],
      'Выбор зависит от задач проекта и бюджета.',
    ],
  },
  {
    question: 'Можно ли дорабатывать лендинг после запуска?',
    blocks: [
      'Да, лендинг можно улучшать и развивать.',
      'После запуска:',
      ['добавляются новые блоки;', 'тестируются гипотезы;', 'улучшается дизайн;', 'усиливается конверсия.'],
      {
        prefix: 'Это нормальный процесс работы с сайтом и у нас есть такая ',
        linkText: 'опция',
        href: '/services/websites/redesign-support/',
      },
    ],
  },
];

function BulletList({ items }) {
  return (
    <ul className="source-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
}

function TextBlocks({ blocks }) {
  return (
    <>
      {blocks.map((block, index) => {
        if (Array.isArray(block)) return <BulletList items={block} key={`list-${index}`} />;
        if (typeof block === 'object') {
          return (
            <p key={block.prefix}>
              {block.prefix}
              <SiteLink href={block.href}>{block.linkText}</SiteLink>
            </p>
          );
        }
        return <p key={block}>{block}</p>;
      })}
    </>
  );
}

function SectionHeader({ title, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <h2>{title}</h2>
      </div>
      {description ? <p className="sub">{description}</p> : null}
    </div>
  );
}

function LandingDevelopmentPage() {
  const [activeType, setActiveType] = useState(0);
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <RedesignPage>
      <PageMeta
        title="Разработка лендинга под ключ - заказать создание продающего лендинга с высокой конверсией и заявками"
        description="Закажите профессиональную разработку лендинга любой сложности под ключ. Создание лендинга с уникальным дизайном под ваш запрос и задачи. Продающий одностраничный сайт -  качественно, супер-быстро и креативно. Системный подход, множество кейсов и команда профессионалов. Разработали более 150 лендингов. Рассчитайте стоимость в студии fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
      />
      <RedesignHeader />

      <section className="ink service-hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-340px', width: '980px', height: '980px', opacity: 0.1 }}
        />
        <div className="container">
          <div>
            <h1>Разработка лендинга под ключ</h1>
            <p className="hero-sub">
              Лендинг — это одностраничный сайт, который приводит клиентов и продажи. Такой сайт создается под конкретную
              задачу: привлечь заявки, протестировать продукт или запустить рекламу. Разработка лендинга включает анализ,
              дизайн, программирование и запуск — всё под ключ.
            </p>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            title="Разработка лендинга для бизнеса"
            description="Разработка лендинга — это создание сайта, который решает конкретную задачу бизнеса. Такой одностраничный сайт помогает быстро запустить продажи, протестировать нишу или собрать лиды."
          />
          <p className="service-hero-copy" style={{ color: '#141619' }}>
            Лендинг используют компании, которым важно:
          </p>
          <BulletList items={proofItems} />
          <p className="service-hero-copy" style={{ color: '#141619' }}>
            Правильно созданный лендинг работает как полноценный инструмент маркетинга. Он привлекает посетителей,
            удерживает внимание и переводит в заявки.
          </p>
          <p className="service-hero-copy" style={{ color: '#141619' }}>
            Важно! Лендинг должен быть не просто красивым. Он должен быть продающим и логично выстроенным.
          </p>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            title="Какие задачи решает лендинг"
            description="Создание лендинга помогает бизнесу решать задачи быстрее, чем многостраничный сайт."
          />
          <div className="split-proof">
            <div>
              <p>Лендинг позволяет:</p>
              <BulletList items={taskItems} />
              <p>
                Одностраничный сайт идеально подходит для быстрых запусков. Он
                не перегружен лишними страницами и ведет пользователя к
                целевому действию.
              </p>
              <SiteLink href="#landing-lead" className="btn btn-primary" style={{ marginTop: '32px' }}>
                За стильным, не ИИшным лендингом и заявками - в Fatality
              </SiteLink>
            </div>
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            title="Какие лендинги мы разрабатываем"
            description="Разработка лендингов ведется под разные задачи бизнеса. Каждый проект создается с учетом целевой аудитории и ниши."
            dark
          />
          <div className="corp-type-layout">
            <div className="corp-type-tabs" role="tablist" aria-label="Типы лендингов">
              {landingTypes.map((item, index) => (
                <button
                  className={`corp-type-trigger${activeType === index ? ' active' : ''}`}
                  type="button"
                  onClick={() => setActiveType(index)}
                  role="tab"
                  id={`landing-type-tab-${index}`}
                  aria-controls={`landing-type-panel-${index}`}
                  aria-selected={activeType === index}
                  tabIndex={activeType === index ? 0 : -1}
                  key={item.title}
                >
                  <span>{String(index + 1).padStart(2, '0')}</span>
                  {item.title}
                </button>
              ))}
            </div>
            <div>
              {landingTypes.map((item, index) => (
                <div
                  className="corp-type-detail"
                  role="tabpanel"
                  id={`landing-type-panel-${index}`}
                  aria-labelledby={`landing-type-tab-${index}`}
                  hidden={activeType !== index}
                  key={item.title}
                >
                  <h3>{item.title}</h3>
                  {item.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  <BulletList items={item.bullets} />
                  {item.outro ? <p>{item.outro}</p> : null}
                  <SiteLink href="#landing-lead" className="link-flat">
                    Узнать стоимость
                  </SiteLink>
                  {/* TODO(brand-redesign): получить утверждённую референсную картинку или скриншот для этого типа лендинга. */}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            title="Что входит в разработку лендинга"
            description="Создание лендинга — это комплексная услуга. Каждый этап влияет на результат."
          />
          <ol className="tz-stage-timeline" aria-label="Этапы разработки лендинга">
            {includedSteps.map(([title, text], index) => (
              <li className="tz-stage-step" key={title}>
                <span className="tz-stage-icon" aria-hidden="true">{index + 1}</span>
                <h3>{title}</h3>
                {title === 'SEO-оптимизация лендинга' ? (
                  <p>
                    Настраиваются мета-теги, структура заголовков и скорость загрузки. Это важно для продвижения в
                    поисковых системах. <SiteLink href="/services/seo/">Подробнее здесь</SiteLink>.
                  </p>
                ) : <p>{text}</p>}
              </li>
            ))}
          </ol>
          {/* TODO(brand-redesign): получить сроки выполнения в рабочих днях для каждого этапа; значения в ТЗ отсутствуют. */}
          <SiteLink href="#landing-lead" className="btn btn-primary section-action">
            Начать проект
          </SiteLink>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            title="Технологии разработки лендингов"
            dark
          />
          <div className="tech-tiles">
            {technologies.map((item) => (
              <div className="tech-tile" key={item.title}>
                <h3>{item.title}</h3>
                {item.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
                {item.bullets ? <BulletList items={item.bullets} /> : null}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            title="Как проходит создание лендинга"
          />
          <div className="process-rail process-rail-five">
            {creationSteps.map(([title, text]) => (
              <div className="process-step" key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            title="Подход к разработке лендингов"
          />
          <div className="compact-card-grid">
            {[
              ['Agile / Scrum', 'Работа ведется по этапам с контролем сроков.'],
              ['Прозрачные этапы', 'Каждый этап согласуется с заказчиком.'],
              ['Фокус на конверсии', 'Каждый элемент сайта направлен на получение заявки.'],
            ].map(([title, text]) => (
              <div className="compact-card" key={title}>
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            title="Форматы сотрудничества"
            dark
          />
          <div className="compact-card-grid">
            {collaborationFormats.map(([title, text]) => (
              <div className="compact-card interactive-card" key={title}>
                <span className="tz-card-icon" aria-hidden="true" />
                <h3>{title}</h3>
                <p>{text}</p>
                <SiteLink href="#landing-lead" className="link-flat">
                  Выбрать этот формат
                </SiteLink>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            title="Что вы получаете в итоге"
          />
          <div className="compact-card-grid">
            {deliverables.map(([title, text]) => (
              <div className="compact-card" key={title}>
                <span className="tz-card-icon" aria-hidden="true" />
                {title === 'Оптимизацию под рекламу и SEO' ? (
                  <h3>Оптимизацию под рекламу и <SiteLink href="/services/seo/">SEO</SiteLink></h3>
                ) : <h3>{title}</h3>}
                <p>{text}</p>
              </div>
            ))}
          </div>
          <SiteLink href="#landing-lead" className="btn btn-primary section-action">
            Заказать продающий лендинг
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            title="Поддержка и развитие лендинга"
          />
          <div className="compact-card-grid">
            {supportItems.map(([title, text]) => (
              <div className="compact-card" key={title}>
                <h3>{title}</h3>
                {title === 'Продвижение лендинга' ? (
                  <p><SiteLink href="/services/seo/">SEO</SiteLink> и реклама.(Да-да seo лендинга тоже возможно в некоторых кейсах, и мы это знаем)</p>
                ) : <p>{text}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            title="Стоимость разработки лендинга"
          />
          <div className="pricing-layout">
            <div className="price-list">
              <h3 className="pricing-subhead">От чего зависит цена</h3>
              <BulletList items={['сложность проекта;', 'дизайн;', 'функционал;', 'сроки.']} />
              <h3 className="pricing-subhead">Примерные цены</h3>
              <div className="price-table-scroll">
                <table className="tz-price-table">
                  <thead>
                    <tr>
                      <th scope="col">Тип лендинга</th>
                      <th scope="col">Срок</th>
                      <th scope="col">Стоимость</th>
                    </tr>
                  </thead>
                  <tbody>
                    {priceRows.map(([type, time, price]) => (
                      <tr key={type}>
                        <th scope="row">{type}</th>
                        <td>{time}</td>
                        <td>{price}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="price-note">
              <h3>Как рассчитывается стоимость</h3>
              <p>
                Формируется смета по этапам разработки.
              </p>
              <h3>Получить расчет</h3>
              <p>Есть продукт, идея, цель - напишите и мы реализуем круче любой ИИ.</p>
              {/* TODO(brand-redesign): получить утверждённые фото и имя менеджера для source trust-блока. */}
              <LeadForm
                formId="landing-calc-form"
                idPrefix="landing-calc"
                eyebrow="Форма заявки"
                contactLabel="Телефон или E-mail"
                contactType="text"
                contactPlaceholder="Телефон или E-mail"
                showTelegram={false}
                showCompany={false}
                typeOptions={landingTypes.map(({ title }) => title)}
                typeLabel="Тип сайта"
                submitLabel="Получить расчёт бесплатно"
                taskPlaceholder="Комментарий"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <SectionHeader
            title="Похожие услуги"
          />
          <div className="related-grid">
            {relatedServices.map((item) => (
              <SiteLink href={item.href} className="related-card" key={item.title}>
                <span>{item.title}</span>
              </SiteLink>
            ))}
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <SectionHeader
            title="Кейсы разработки лендингов"
            dark
          />
          <h3 className="standalone-h3 light">Примеры с результатами</h3>
          <p className="service-hero-copy">Реальные проекты с ростом конверсии и продаж.</p>
          <SiteLink href="/portfolio/fitness-course-landing/" className="case-teaser">
            <img className="case-card-image" src="/images/cases/meditation-platform.webp" srcSet="/images/cases/meditation-platform-840.webp 840w, /images/cases/meditation-platform-1280.webp 1280w, /images/cases/meditation-platform.webp 1672w" sizes="(max-width: 1024px) calc(100vw - 40px), 590px" alt="" width="1672" height="941" loading="lazy" />
            <div className="case-teaser-body">
              <strong>Разработка лендинга онлайн-курса по тренировкам под ключ</strong>
              <p>
                Проект включал полный цикл: создание одностраничного сайта,
                разработку структуры, дизайн, SEO-оптимизацию и запуск рекламы.
              </p>
            </div>
          </SiteLink>
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container">
          <SectionHeader
            title="Отзывы клиентов: от идеи - к готовому лендингу и деньгам"
          />
          <ReviewsCarousel className="reviews-grid reviews-grid-three">
            {reviews.map((review) => (
              <figure className="review-card" aria-label={review.full} key={review.name}>
                <blockquote>{review.text}</blockquote>
                <figcaption>{review.full}</figcaption>
              </figure>
            ))}
          </ReviewsCarousel>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="faq-grid">
            <div>
              <h2 className="standalone-h2">Ответы на частые вопросы</h2>
            </div>
            <div className="faq-list">
              {faqItems.map((item, index) => {
                const isOpen = openFaq === index;
                return (
                  <div className={`faq-item${isOpen ? ' open' : ''}`} key={item.question}>
                    <h3>
                      <button
                        className="faq-q"
                        type="button"
                        onClick={() => setOpenFaq(isOpen ? -1 : index)}
                        aria-expanded={isOpen}
                        aria-controls={`landing-faq-answer-${index}`}
                      >
                        <span>{item.question}</span>
                        <span className="faq-toggle" aria-hidden="true" />
                      </button>
                    </h3>
                    <div className="faq-a" id={`landing-faq-answer-${index}`} aria-hidden={!isOpen}>
                      <div className="faq-a-inner">
                        <TextBlocks blocks={item.blocks} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section className="ink lead" id="landing-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <h2 className="lead-heading">Заказать разработку лендинга</h2>
              <p className="lead-text">
                Расскажите о своём проекте — команда подготовит предварительную смету и ответит на вопросы в течение
                рабочего дня.
              </p>
            </div>
            <LeadForm
              formId="landing-lead-form"
              idPrefix="landing"
              eyebrow="Форма заявки"
              contactLabel="Телефон или E-mail"
              contactType="text"
              contactPlaceholder="Телефон или E-mail"
              showTelegram={false}
              showCompany={false}
              typeOptions={landingTypes.map(({ title }) => title)}
              typeLabel="Тип сайта"
              submitLabel="Получить расчёт бесплатно"
              taskPlaceholder="Комментарий"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default LandingDevelopmentPage;
